import BottomAction from 'components/BottomAction';
import Pageheader from 'components/Pageheader'
import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { useNavigate } from 'react-router-dom';
import QRCode from 'qrcode.react';
import useProfileStore from 'services/store/ProfileModule';
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';

const CustomerQr = () => {
    const navigate = useNavigate();
    const lineProfile = useProfileStore();
    const profile = lineProfile?.customerProfile
    const [refreshing, setRefreshing] = useState(false)
    const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
    const { t } = useTranslations();
    const handleBack = () => {
        navigate('/profile');
    }
    const handleRefresh = () => {
        console.log('handleRefresh!!!')
        setRefreshing(true)
        onLoad();
    }
    const onLoad = () => {
        setRefreshing(false)
    }
    return (
        <>
            <PullToRefresh
                refreshing={refreshing}
                onRefresh={handleRefresh}
            >
                <Helmet>
                    <title>IMPACT Family</title>
                    <meta name="title" content="Impact Family" />
                    <meta name="description" content="Impact Family" />
                    <meta name="keyword" content="" />
                    <meta property="og:title" content="Impact Family" />
                    <meta property="og:description" content="Impact Family" />
                    <meta property="og:image" content="" />
                    <meta property="og:url" content="" />
                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Impact Family" />
                </Helmet>
                <div id="pageQR-customer">
                    <Pageheader pagename={t.collectPoint.pointCollection} onClick={handleBack} />
                    <main id="top">
                        <div class="wrapContent">
                            <section id="pQR">
                                <div class="bQR">
                                    <h2>{t.collectPoint.scan}</h2>
                                    <div class="bGroup">
                                        <p>{t.collectPoint.show}</p>
                                        <div class="bPic">
                                            <QRCode value={profile.custCode} size={145} />
                                            {/* <img src="https://dummyimage.com/145x145/667085/fff" /> */}
                                        </div>
                                        <div class="bMembercode">
                                            <p>{t.collectPoint.code} <span>{profile.custCode}</span></p>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <BottomAction classBtn2='hide' handleBack={handleBack} />
                            {/* <!-- Page Button Menu -->
                        <?php $classBtn2 = "hide"; include 'inc/inc-bottom-action.php';?> */}

                        </div>
                    </main>

                </div>
            </PullToRefresh>
        </>
    )
}

export default CustomerQr